import { render } from "./FAQView.vue?vue&type=template&id=78fadf7e"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__